export type PropertyOwnerUserData = {
  first_name: string;
  email: string;
  phone: string;
};

export type PropertyOwnerMode = {
  user_id?: number;
  partner_broker_id?: number;
  user_data?: PropertyOwnerUserData;
};

export function hasPropertyOwner(owner: PropertyOwnerMode): boolean {
  if (owner.user_data?.email?.trim()) return true;
  return owner.user_id != null && Number.isFinite(owner.user_id);
}

/**
 * Draft/create APIs accept either an existing `user_id` or a new `user_data`
 * payload — never both. Prefer `user_id` when present so auto-save does not
 * keep re-sending `user_data` after the owner was already created.
 */
export function applyPropertyOwnerToPayload(
  payload: Record<string, unknown>,
  owner: PropertyOwnerMode
): Record<string, unknown> {
  const next: Record<string, unknown> = { ...payload };
  delete next.user_data;
  delete next.user_id;
  delete next.partner_broker_id;

  if (owner.user_id != null && Number.isFinite(owner.user_id) && owner.user_id > 0) {
    next.user_id = owner.user_id;
    if (
      owner.partner_broker_id != null &&
      Number.isFinite(owner.partner_broker_id)
    ) {
      next.partner_broker_id = owner.partner_broker_id;
    }
    return next;
  }

  const email = owner.user_data?.email?.trim();
  if (email) {
    next.user_data = {
      first_name: owner.user_data?.first_name ?? "",
      email,
      phone: owner.user_data?.phone ?? "",
    };
    return next;
  }

  return next;
}

export function resolveOwnerStateAfterDraftSave(
  current: PropertyOwnerMode,
  savedUserId: number | undefined
): PropertyOwnerMode {
  if (
    savedUserId == null ||
    !Number.isFinite(savedUserId) ||
    savedUserId <= 0
  ) {
    return current;
  }

  return {
    user_id: savedUserId,
    partner_broker_id: current.partner_broker_id,
    user_data: undefined,
  };
}
